import React from 'react';

const C = { primary: '#8B1A1A', bg: '#FFF8F0' };

function InformationPage({ title, intro, sections }) {
  return (
    <main style={{ maxWidth: 850, margin: '0 auto', padding: '48px 24px 72px' }}>
      <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 36, color: '#2C2C2C', marginBottom: 8 }}>
        {title}
      </h1>
      <p style={{ color: '#888', fontSize: 13, marginBottom: 28 }}>Last updated: 31 July 2026</p>
      <p style={{ color: '#555', lineHeight: 1.8, marginBottom: 28 }}>{intro}</p>
      {sections.map(section => (
        <section key={section.title} style={{ marginBottom: 28 }}>
          <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 21, color: C.primary, marginBottom: 10 }}>
            {section.title}
          </h2>
          {section.paragraphs.map(paragraph => (
            <p key={paragraph} style={{ color: '#555', lineHeight: 1.8, marginBottom: 10 }}>
              {paragraph}
            </p>
          ))}
        </section>
      ))}
    </main>
  );
}

const contactText = 'For questions, contact rohini@a1looks.com or +91 7042544844.';

export function Contact() {
  return (
    <main style={{ maxWidth: 850, margin: '0 auto', padding: '48px 24px 72px' }}>
      <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 36, color: '#2C2C2C', marginBottom: 20 }}>
        Contact Us
      </h1>
      <div style={{ background: C.bg, border: '1px solid #f0e0e0', borderRadius: 10, padding: 28, color: '#555', lineHeight: 2 }}>
        <p><strong>A1 Looks</strong></p>
        <p>Neo Town Road, Bangalore 560100, India</p>
        <p>Email: <a href="mailto:rohini@a1looks.com">rohini@a1looks.com</a></p>
        <p>Phone: <a href="tel:+917042544844">+91 7042544844</a></p>
        <p style={{ marginTop: 16 }}>Monday–Saturday: 10 AM–7 PM IST</p>
        <p>Sunday: 11 AM–5 PM IST</p>
      </div>
    </main>
  );
}

export function PrivacyPolicy() {
  return <InformationPage
    title="Privacy Policy"
    intro="A1 Looks uses customer information only to operate the store, complete orders, provide support, and meet legal obligations."
    sections={[
      { title: 'Information we collect', paragraphs: ['We may collect account details, contact information, shipping addresses, order contents, payment status, and technical information needed to secure and operate the website. A1 Looks does not collect or store complete card, UPI, or banking credentials.'] },
      { title: 'How information is used', paragraphs: ['We use this information to process and deliver orders, prevent fraud, respond to support requests, maintain customer accounts, and improve store operations.'] },
      { title: 'Service providers', paragraphs: ['Information may be shared with providers that perform necessary services such as Cashfree Payments, hosting, delivery, analytics, and customer support. They receive only the information required to provide those services.'] },
      { title: 'Your choices', paragraphs: [`You may request access, correction, or deletion of eligible personal information. ${contactText}`] },
    ]}
  />;
}

export function ShippingPolicy() {
  return <InformationPage
    title="Shipping Policy"
    intro="A1 Looks ships orders within India to the address supplied during checkout."
    sections={[
      { title: 'Processing and delivery', paragraphs: ['Orders are normally processed on business days. Estimated delivery is 3–7 business days after dispatch, although remote locations, holidays, weather, and carrier delays may require additional time.'] },
      { title: 'Charges and tracking', paragraphs: ['The applicable shipping charge is displayed before payment. Shipping is free when the discounted merchandise subtotal meets the free-shipping threshold shown at checkout. Tracking details are provided when available.'] },
      { title: 'Address issues', paragraphs: ['Customers are responsible for providing a complete and accurate delivery address. Contact us promptly if a correction is needed before dispatch.'] },
    ]}
  />;
}

export function TermsAndConditions() {
  return <InformationPage
    title="Terms & Conditions"
    intro="By placing an order with A1 Looks, you agree to these store terms."
    sections={[
      { title: 'Products and pricing', paragraphs: ['Products are subject to availability. Prices, offers, descriptions, and stock may change, but an accepted payment is charged at the server-confirmed checkout total. Handcrafted products may have minor variations in colour, finish, or pattern.'] },
      { title: 'Orders and payment', paragraphs: ['An order is accepted after payment is successfully confirmed. A pending or failed payment does not guarantee fulfilment. We may contact you or cancel and refund an order when fulfilment is impossible, fraud is suspected, or material listing errors occurred.'] },
      { title: 'Website use', paragraphs: ['You may not misuse the website, attempt unauthorised access, interfere with payments, or copy store content in violation of applicable rights.'] },
      { title: 'Contact', paragraphs: [contactText] },
    ]}
  />;
}

export function RefundPolicy() {
  return <InformationPage
    title="Refund & Cancellation Policy"
    intro="We want delivered products to match the order and arrive in acceptable condition."
    sections={[
      { title: 'Cancellations', paragraphs: ['Request cancellation as soon as possible. An order can be cancelled only before dispatch. Once dispatched, the return eligibility below applies.'] },
      { title: 'Damaged, defective, or incorrect items', paragraphs: ['Contact us within 7 days of delivery with the order reference and clear photographs. Keep the item unused and in its original packaging while the request is reviewed.'] },
      { title: 'Approved refunds', paragraphs: ['After an approved return is received and inspected, the refund is initiated to the original payment method. Bank or payment-provider processing time may apply. Original shipping charges are not refundable unless the item was damaged, defective, or incorrect.'] },
      { title: 'Contact', paragraphs: [contactText] },
    ]}
  />;
}
